import { object, string } from 'yup';

export const zipCodePattern = /^((0[1-9])|([1-8][0-9])|(9[0-5])|98)[0-9]{3}$/;

export const validationSchema = object().shape({
  firstName: string().required('Champ obligatoire').max(40, '40 caractères max'),
  lastName: string().required('Champ obligatoire').max(60, '60 caractères max'),
  address: string().required('Champ obligatoire').max(256, '256 caractères max'),
  city: string().required('Champ obligatoire'),
  country: string().required('Champ obligatoire'),
  phone: string().required('Champ obligatoire'),
  zipCode: string().required('Champ obligatoire').matches(zipCodePattern, 'Code postal invalide'),
});
